'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useQuery } from '@tanstack/react-query';
import type { POLICY_APPLICATION_TYPE } from '@/api';
import { AuthQueryOptions } from '@/api';
import { PageNavigation } from '@/components/client';
import { API_ROUTES, BASE_URL, ROUTES } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import type { ApplyPolicyCardProps } from './_components/ApplyPolicyCard';
import { ApplyPolicyCard } from './_components/ApplyPolicyCard';
const MyApplyPage = () => {
  const $ = _c(27);
  const osType = useDeviceInfoStore(_temp);
  const {
    accessToken,
    refreshToken
  } = useAccessToken();
  const {
    isWelloApp
  } = useCheckWelloApp();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/policy-apply/history"](),
      select: _temp3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const policyApplyQuery = useQuery(t0);
  let t1;
  if ($[1] !== policyApplyQuery.data?.applyPolicyList) {
    t1 = policyApplyQuery.data?.applyPolicyList ?? [];
    $[1] = policyApplyQuery.data?.applyPolicyList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const applyPolicyList = t1;
  const totalCount = policyApplyQuery.data?.totalCount ?? 0;
  const isShowEmpty = applyPolicyList.length < 1 && !policyApplyQuery.isLoading;
  let t2;
  if ($[3] !== accessToken || $[4] !== isWelloApp || $[5] !== osType || $[6] !== refreshToken) {
    t2 = () => {
      window.location.href = API_ROUTES.BENEFIT_NOTIFICATION.withSearchParams({
        dynamicPath: {
          dynamicPath: "application-results-url"
        },
        searchParams: {
          osType,
          accessToken,
          refreshToken,
          isWelloApp
        }
      });
    };
    $[3] = accessToken;
    $[4] = isWelloApp;
    $[5] = osType;
    $[6] = refreshToken;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleClickBenefitNotificationList = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...AuthQueryOptions["get:/wello/v2/auth/benefit-notification/service-usage-agreement-management-url"]({
        query: {
          callbackUrl: `${BASE_URL}${ROUTES.MY_APPLY.pathname}`,
          cncltnUrl: `${BASE_URL}${ROUTES.MY_APPLY.pathname}`
        }
      }),
      select: _temp4
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const benefitNotificationAgreementQuery = useQuery(t3);
  let t4;
  if ($[9] !== benefitNotificationAgreementQuery.data) {
    t4 = benefitNotificationAgreementQuery.data ?? {};
    $[9] = benefitNotificationAgreementQuery.data;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    viewUrl
  } = t4;
  const hasAgreement = !viewUrl;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PageNavigation backButton={true} title={"\uBC14\uB85C\uC2E0\uCCAD \uB0B4\uC5ED"} />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== totalCount) {
    t6 = <p className="h-32 font-400 text-Gray-900 typo-body4">총 {totalCount}개</p>;
    $[12] = totalCount;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== handleClickBenefitNotificationList || $[15] !== hasAgreement) {
    t7 = hasAgreement ? <Button dimensions="H32" theme="sub-line" onClick={handleClickBenefitNotificationList}>혜택알리미 신청내역</Button> : null;
    $[14] = handleClickBenefitNotificationList;
    $[15] = hasAgreement;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="flex items-center justify-between px-20 py-10">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== applyPolicyList || $[21] !== isShowEmpty || $[22] !== policyApplyQuery.isLoading) {
    t9 = !isShowEmpty ? <ul className="flex flex-col gap-20 px-20 pt-12">{policyApplyQuery.isLoading ? Array.from({
        length: 3
      }).map(_temp5) : null}{applyPolicyList.map(_temp6)}</ul> : <div className="flex flex-1 items-center justify-center font-400 text-Gray-600 typo-body3">바로신청 내역이 없어요</div>;
    $[20] = applyPolicyList;
    $[21] = isShowEmpty;
    $[22] = policyApplyQuery.isLoading;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <article className="flex w-full min-w-0 flex-col pt-40 mobile-tablet:pt-0">{t5}{t8}{t9}</article>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default MyApplyPage;
function _temp(state) {
  return state.osType;
}
function _temp2(policy) {
  return {
    name: policy.policyName,
    idx: policy.idIdx,
    agencyLogoUrl: policy.agencyLogo,
    applicationType: policy.policyApplicationTypeCd as POLICY_APPLICATION_TYPE
  } satisfies ApplyPolicyCardProps;
}
function _temp3(t0) {
  const {
    context
  } = t0;
  return {
    applyPolicyList: context?.contents?.map(_temp2),
    totalCount: context?.totalCount
  };
}
function _temp4(t0) {
  const {
    context: context_0
  } = t0;
  return {
    viewUrl: context_0?.viewUrl ?? ""
  };
}
function _temp5(_, idx) {
  return <li key={idx}><ApplyPolicyCard isLoading={true} /></li>;
}
function _temp6(applyPolicy) {
  return <li key={applyPolicy.idx}><ApplyPolicyCard {...applyPolicy} /></li>;
}